package com.tixforgigs.common.core.extensions

val Any?.isNull get() = this == null
val Any?.isNotNull get() = this != null

inline fun <T> T?.orElse(fallback: () -> T): T = this ?: fallback()